// define this as a provider so it can be used in the config method in FrontRoyal/angularModuleAngular/index.js
export default angular
    .module('Capabilities', [])
    .provider('Capabilities', [
        '$windowProvider',

        function ($windowProvider) {
            const $window = $windowProvider.$get();
            const Capabilities = {};

            // depend on Modernizr to resolve touch capability
            Object.defineProperty(Capabilities, 'touchEnabled', {
                get() {
                    return $window.Modernizr && $window.Modernizr.touchevents;
                },
                configurable: true, // tests
            });

            // depend on Modernizr to resolve localStorage support
            Object.defineProperty(Capabilities, 'localStorage', {
                get() {
                    return $window.Modernizr && $window.Modernizr.localstorage; // all lowercase  =/
                },
                configurable: true, // tests
            });

            // depend on Modernizr to resolve sessionStorage support
            Object.defineProperty(Capabilities, 'sessionStorage', {
                get() {
                    return $window.Modernizr && $window.Modernizr.sessionstorage; // all lowercase  =/
                },
                configurable: true, // tests
            });

            Object.defineProperty(Capabilities, 'cookies', {
                get() {
                    return $window.Modernizr && $window.Modernizr.cookies; // all lowercase  =/
                },
                configurable: true, // tests
            });

            Object.defineProperty(Capabilities, 'cssTransitions', {
                get() {
                    return $window.Modernizr.csstransitions;
                },
                configurable: true,
            });

            return {
                $get() {
                    return Capabilities;
                },
            };
        },
    ])

    // blockAuthenticatedAccess service - moved here to avoid circular dependency
    // between Authentication and Navigation modules
    .factory('blockAuthenticatedAccess', [
        '$injector',

        $injector => {
            const Capabilities = $injector.get('Capabilities');
            const obj = {};

            /*
            Right now, the only reason we block authenticated access
            is because cookies are disabled.  Possible there could
            be other reasons to do so at some point.  This could maybe
            even be used for some kinds of site downtime or something.
        */
            Object.defineProperty(obj, 'block', {
                get() {
                    return !Capabilities.localStorage && !Capabilities.cookies;
                },
                configurable: true, // tests
            });

            Object.defineProperty(obj, 'errorMessage', {
                get() {
                    if (this.block) {
                        return 'You must enable cookies to login to smart.ly';
                    }
                    return undefined;
                },
                configurable: true, // tests
            });

            return obj;
        },
    ]);
